<script>
export default {
  name: "DidoMillesimeTabHistoricalDatas",
};
</script>

<script setup>
import DidoResourcesPagination from "../../commons/resources-pagination/Pagination.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  historicalDatas: { type: Object, required: true },
});
</script>

<template>
  <div>
    <DidoResourcesPagination
      :api-url="props.apiUrl"
      :resources="props.historicalDatas"
      type="historicalDatas"
    />
  </div>
</template>
